import dynamic from 'next/dynamic';
import type { FunctionComponent, PropsWithChildren } from 'react';

import { useListingError } from '../../hooks/useListingError';

const Error500 = dynamic<PropsWithChildren<unknown>>(() =>
  import('@/domains/core/page/components/Error50x/Error500').then(
    (mod) => mod.Error500,
  ),
);

export const ErrorBoundary: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const { message, httpStatus } = useListingError() || {};

  if (message || httpStatus) {
    return <Error500 />;
  }
  return <>{children}</>;
};

ErrorBoundary.displayName = 'ErrorBoundary';
